import { Button } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

const CompanyDetailsPage = () => {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [userUpdateDate, setUserUpdateDate] = useState('');
  const [userDetailsIsFilled, setUserDetailsIsFilled] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          `https://kariyer.biyomed.net/api/admin/getOneCompanyDetailsAdmin/${id}`, // id'yi nesne içine aldık
          { withCredentials: true } // Cookie gönderimi için
        );
        setUserUpdateDate(response.data.company.created_at)
        const res = await axios.get(
          `https://kariyer.biyomed.net/api/admin/getOneCompanyAdmin/${id}`, // id'yi nesne içine aldık
          { withCredentials: true } // Cookie gönderimi için
        );

        setUserDetailsIsFilled(true);
        setUser({ ...res.data.company, ...response.data.company });
      } catch (error) {
        console.error("Error fetching user:", error);
        setUserDetailsIsFilled(false);
      }
    };

    if (id) {
      fetchUser();
    }
  }, [id]);  // id değişirse yeniden çalıştır



  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith('data:application/pdf;base64,')) {
      const base64Data = pdfData.split('base64,')[1];  // Base64 verisini ayıklama

      const pdfBlob = new Blob([new Uint8Array(atob(base64Data).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };





  return (
    <div className="jp_cp_profile_main_wrapper">
      <Button sx={{ backgroundColor: "#4b88bd", marginTop: -20 }}><a style={{ color: 'white' }} href='/admin/firmalar'> Geri don</a></Button>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="jp_cp_left_side_wrapper">
              <div className="jp_cp_left_pro_wallpaper">
                <img src={user.profile_image ? user.profile_image : " https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"} alt="profile_img" />

              </div>
            </div>
          </div>
          {userDetailsIsFilled ? (
            <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <div className="jp_cp_right_side_wrapper">
                <div className="jp_cp_right_side_inner_wrapper">
                  <h2>Kullanıcı Detay</h2>
                <table>
                  <tbody>
                  <tr>
                        <td className="td-w25">Kayıt Bilgileri Güncelleme Tarihi</td>
                        <td className="td-w10">:</td>
                        <td className="td-w65">
                          {new Date(userUpdateDate).toLocaleString()} {/* Hem tarihi hem de saati göstermek için */}
                        </td>
                      </tr>
                      <tr>
                      <td className="td-w25">Yetki Durumu</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.user_type}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Firma/Sağlık Kuruluşu Adı</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.company_name}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">E-posta</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.email}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Telefon</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.phone}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Web Sayfası</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.website}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">İl</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.city}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Adres</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">
                        {user?.company_address}
                      </td>
                    </tr>
                    <tr>
                      <td className="td-w25">Vergi No/ ÜTS Firma No</td>
                      <td className="td-w10">:</td>
                      <td className="td-w65">{user?.company_number}</td>
                    </tr>
                    <tr>
                      <td className="td-w25">Destekleyici Döküman</td>
                      <td className="td-w10">:</td>
                      <td>
                        {user.support_document && (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleDownload(user.support_document, `${user.first_name}_support_document.pdf`)}
                            startIcon={<FaFilePdf />}
                          >
                            Belgeyi indir
                          </Button>
                        )}
                      </td>

                    </tr>
                  </tbody>
                </table>


                </div>
              </div>
            </div>
          ) : (
            <div> Detay Bilgileri Yükleniyor Lütfen Bekleyiniz ...</div>
          )}
        </div>
      </div>

    </div>
  );
};

export default CompanyDetailsPage;
